export default "__VITE_ASSET__BLrPDYXG__"